import { Field, SectionTitle } from "@/components/admin/fields";
import { CONTACT_PHONE, CONTACT_EMAIL } from "@/constants/site";

export const ContactEditor = ({ contact, onChange }) => {
  const isPlaceholder = contact.phone === CONTACT_PHONE || contact.email === CONTACT_EMAIL;
  return (
    <section>
      <SectionTitle hint="Shown in the footer and used for tap-to-call / tap-to-email.">Contact info</SectionTitle>
      {isPlaceholder && (
        <div
          data-testid="admin-contact-placeholder-warning"
          className="mb-4 border border-[#E60000]/50 bg-[#E60000]/10 px-4 py-3 text-sm text-[#FF6B6B]"
        >
          These are still placeholders — swap in your real phone and email so customers can reach you.
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field
          label="Phone (call or text)"
          testId="admin-contact-phone"
          type="tel"
          value={contact.phone}
          maxLength={30}
          placeholder="(321) 555-0123"
          onChange={(e) => onChange({ ...contact, phone: e.target.value })}
        />
        <Field
          label="Email"
          testId="admin-contact-email"
          type="email"
          value={contact.email}
          maxLength={80}
          placeholder="you@marrmobiledetailing.com"
          onChange={(e) => onChange({ ...contact, email: e.target.value })}
        />
      </div>
    </section>
  );
};

export default ContactEditor;
